module.exports = __webpack_public_path__ + "static/media/RP-72.d3acd55d.pdf";